
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { LoadPaymentFoundationTrusteeState, LoadPaymentFoundationTrusteeStateSuccess, LoadPaymentFoundationTrusteeStateFail, PaymentFoundationTrusteeActionTypes, ProcessPaymentFoundationTrustee, LoadProcessedPaymentFoundationTrusteeState, LoadProcessedPaymentFoundationTrusteeStateSuccess, UpdateToCheckIssueFoundationTrustee } from './payment-foundation-trustee.actions';
import { LGEDataService } from '../../../commons';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

@Injectable()
export class PaymentFoundationTrusteeEffects {


  loadPaymentFoundationTrusteeState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentFoundationTrusteeActionTypes.LoadPaymentFoundationTrusteeState),
      switchMap(
        () => this.lgeData.GetFoundationPaymentRequests()
      ),
      switchMap(
        rq => [new LoadPaymentFoundationTrusteeStateSuccess(rq),
        new LoadProcessedPaymentFoundationTrusteeState()]
      ),
      catchError(error => of(new LoadPaymentFoundationTrusteeStateFail(error)))
    )
  )

  processPaymentFoundationTrustee$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentFoundationTrusteeActionTypes.ProcessPaymentFoundationTrustee),
      map((action: ProcessPaymentFoundationTrustee) => action.payload),
      switchMap((requests) => this.lgeData.ProcessFoundationPaymentRequests(requests)),
      switchMap(
        rq => [new LoadPaymentFoundationTrusteeStateSuccess(rq),
        new LoadProcessedPaymentFoundationTrusteeState()]),
      catchError(error => of(new LoadPaymentFoundationTrusteeStateFail(error)))
    )
  )

  updateStatusPaymentFoundationTrustee$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentFoundationTrusteeActionTypes.UpdateToCheckIssueFoundationTrustee),
      map((action: UpdateToCheckIssueFoundationTrustee) => action.payload),
      switchMap((requests) => this.lgeData.UpdateFoundationPaymentRequestsStatus(requests)),
      switchMap(
        rq => [new LoadPaymentFoundationTrusteeStateSuccess(rq),
        new LoadProcessedPaymentFoundationTrusteeState()]),
      catchError(error => of(new LoadPaymentFoundationTrusteeStateFail(error)))
    )
  )

  loadProcessedPaymentFoundationTrusteeState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentFoundationTrusteeActionTypes.LoadProcessedPaymentFoundationTrusteeState),
      switchMap(
        () => this.lgeData.GetProcessedFoundationPaymentRequests().pipe(
          map(rq => new LoadProcessedPaymentFoundationTrusteeStateSuccess(rq)),
          catchError(error => of(new LoadPaymentFoundationTrusteeStateFail(error)))
        )
      )
    )
  )
  constructor(
    private actions$: Actions,
    private lgeData: LGEDataService
  ) { }
}